import { AsyncState } from 'widgets-for-react'
import { ImageData } from '../../image/imageState'
import { loadDishTeasers as loadDishTeasers } from './dishTeasersApi'

export type DishTeasersState = AsyncState<DishTeasersData>

export type DishTeasersData = DishTeaserData[]

export type DishTeaserData = {
  Id: number
  Path: string
  HeaderTitle: string
  HeaderImage: ImageData
}

export const initialDishTeasersState = (
  apicall: () => Promise<any>
): DishTeasersState => loadDishTeasers(apicall)
